__turbopack_context__.v({
  "block": "Header-module-scss-module__j8qwLa__block",
  "container": "Header-module-scss-module__j8qwLa__container",
  "header": "Header-module-scss-module__j8qwLa__header",
  "mobile": "Header-module-scss-module__j8qwLa__mobile",
  "padding": "Header-module-scss-module__j8qwLa__padding",
});
